import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import { navigate } from "gatsby"
import { colors } from "../../constants"

const Card = styled(Grid)({
  background: "#ffffff",
  borderRadius: 3,
  height: 400,
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  width: 300,
  transition: ".3s",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0 5px 5px rgba(0,0,0,0.4), 0 -4px 5px -2px #6d95ce inset",
  },
})

const ImageWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
  height: 250px;
`

const Title = styled.span({
  color: colors.brand,
  fontSize: "20px",
  whiteSpace: "pre",
  fontFamily: "Avenir Next",
  display: "block",
  textAlign: "center",
  "&:hover": {
    opacity: 0.6,
  },
})

export default class ContentCard extends Component {
  handleClick = () => {
    const { url } = this.props
    navigate(url)
  }
  render() {
    const { title, src } = this.props
    return (
      <Card onClick={this.handleClick}>
        <GridWrapper style={{ height: "150px" }}>
          <Title>{title}</Title>
          <Title style={{ marginLeft: "8px", fontWeight: "bold" }}>></Title>
        </GridWrapper>
        <ImageWrapper>
          <img src={src} alt={"logo"} style={{ width: "300px" }} />
        </ImageWrapper>
      </Card>
    )
  }
}
